import * as R from 'ramda'

/**
 * It looks up into memberships(array) and checks if member corresponding to userId is an owner
 * @param memberships
 * @param userId
 * @returns {*}
 */
export default (memberships, userId) => {
  const isOwner = R.compose(
    R.equals('owner'),
    R.prop('type'),
    R.find(R.propEq('userId', userId))
  )
  return isOwner(memberships)
}
